import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from '../../../../components/Intl/withIntl.js';
import { Helmet } from '../../../../components/Content/Helmet.js';
import { Container, Card } from 'react-bootstrap';
import Icon from '../../../../components/Content/Icon.js';

// Import Components

import withRouter from '../../../../components/Router/WithRouter.js';
import PageWrapper from '../../../../components/Content/PageWrapper.js';
import UserLoginForm from '../../components/auth/UserLoginForm.js';
import UserNewsletterSubscribe from '../../components/newsletter/UserNewsletterSubscribe.js';

function UserLoginPage({ intl, location, search = {}, redirect = '' }) {
    return (
        <div className="page-wrapper pb-3">
            <Helmet
                title={intl.formatMessage({ id: 'userLogin', defaultMessage: 'Login' })}
                meta={[
                    {
                        name: 'robots',
                        content: 'noindex, nofollow',
                    },
                ]}
            >
                <body data-header-contrast="false" />
            </Helmet>
            <Container className="bg-company">
                <PageWrapper>
                    <Card className="shadow">
                        <Card.Header>
                            <Card.Title as="h1" className="h4 mb-0">
                                <Icon icon="user" aria-hidden="true" /> <FormattedMessage id="userLogin" defaultMessage="Login" />
                            </Card.Title>
                        </Card.Header>
                        <Card.Body className="p-4">
                            <UserLoginForm redirect={redirect || location.pathname} email={search.get('email')} password={search.get('password')} code={search.get('code')} noWrapper />
                        </Card.Body>
                    </Card>
                </PageWrapper>
            </Container>
            {/* Secondary to the login task: no card, no shadow, so it never competes with the form above */}
            <Container className="mt-5">
                <PageWrapper>
                    <UserNewsletterSubscribe />
                </PageWrapper>
            </Container>
        </div>
    );
}

UserLoginPage.propTypes = {
    location: PropTypes.object.isRequired,
    search: PropTypes.object,
    intl: PropTypes.object.isRequired,
    redirect: PropTypes.string,
};

export default withRouter(injectIntl(UserLoginPage));
